module.exports = __webpack_public_path__ + "img/select_all.fca93317.svg";